export default __webpack_public_path__ + "static/media/blueCircleDollar.dddbd898.svg";